import { ref, type Ref } from 'vue';

export const popStateDetected: Ref<boolean> = ref(false);
export const isExitingEstate: Ref<boolean> = ref(false);
